import styled from 'styled-components';

export const PageSwitcherSC = styled.div`
  display: flex;
  padding-top: 15px;
  margin-top: 15px;
  border-top: 1px solid rgba(217, 217, 217, 0.2);
  .controls {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .back {
      width: 32px;
      height: 32px;
      cursor: pointer;
      &.disabled {
        opacity: 0.5;
      }
      svg {
        transform: rotateZ(180deg);
      }
    }
    .count {
      display: flex;
      align-items: center;
      .dot {
        width: 8px;
        height: 8px;
        margin: 0 5px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.4);
        cursor: pointer;
        &.active {
          background: rgba(255, 255, 255, 1);
        }
      }
    }
    .next {
      width: 32px;
      height: 32px;
      cursor: pointer;
      &.disabled {
        opacity: 0.5;
      }
    }
  }
`;
